export default "__VITE_ASSET__DGWHW9UP__"